import Cookies from 'js-cookie'
import {sessonDao} from "@/utils/Hibernate";
const TokenKey = 'Customer-Token'
import store from "@/store";
const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  return (store && store.state.auth.token) || sessonDao.getString(TokenKey) || null;
}

export function setToken(token) {
  console.log(token)
  sessonDao.setString(TokenKey, token)
  store.dispatch("auth/setData", {
    key: "token",
    data: token
  })
}


export function removeToken() {
  sessonDao.remove(TokenKey)

}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}
